import { render, staticRenderFns } from "./RandomCompTest.vue?vue&type=template&id=5bf66c3a&"
import script from "./RandomCompTest.vue?vue&type=script&lang=js&"
export * from "./RandomCompTest.vue?vue&type=script&lang=js&"
import style0 from "./RandomCompTest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports